export const SupportedLocaleCodes = ['en-US', 'fr-CA', 'ko'];

export interface Locale {
  code: (typeof SupportedLocaleCodes)[number];
  name: string;
  beta?: boolean;
}

export const groupLocaleUnitNames = {
  customSegmentDescriptions: '@@groupCustomSegmentDescription',
  customSegmentOptions: '@@groupCustomSegmentOption',
  customSegmentTitles: '@@groupCustomSegmentTitle',
  goals: '@@groupOffering',
  interests: '@@groupIndustry',
  roles: '@@groupRole',
};

export const localizedGroupLocaleUnitNames = {
  customSegmentDescriptions: $localize`:@@groupLocale.customSegmentDescription: Segment description`,
  customSegmentOptions: $localize`:@@groupLocale.customSegmentOption:Segment option`,
  customSegmentTitles: $localize`:@@groupLocale.customSegmentTitle:Segment title`,
  goals: $localize`:@@groupLocale.goals:Goals`,
  interests: $localize`:@@groupLocale.interests:Interests`,
  roles: $localize`:@@groupLocale.roles:Roles`,
};

export interface TranslationLookupMap {
  [key: (typeof SupportedLocaleCodes)[number]]: TranslationUnitForLookup;
}

export interface TranslationUnitForLookup {
  [key: string]: { [key: string]: string };
}
